import { render, staticRenderFns } from "./AutocompleteTeacher.vue?vue&type=template&id=1d3090cf"
import script from "./AutocompleteTeacher.vue?vue&type=script&lang=js"
export * from "./AutocompleteTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports